import DefaultLayout from "components/layouts/DefaultLayout"
import SEOData from "components/SEOData"
import Link from "next/link"
import { MDXRemote } from "next-mdx-remote"
import PropTypes from "prop-types"
import Container from "reactstrap/lib/Container"

const components = {
  // eslint-disable-next-line react/prop-types
  a: ({ href, ...rest }) => (
    <Link href={href} passHref>
      {/* eslint-disable-next-line */}
      <a {...rest} />
    </Link>
  )
}

export default function LegalScene({ markdown, pageName, title }) {
  return (
    <DefaultLayout topBarProps={{ dark: true, pageName }} footerProps={{ pageName }}>
      <SEOData title={title} description="" />
      <Container>
        <MDXRemote {...markdown} components={components} lazy />
      </Container>
    </DefaultLayout>
  )
}

LegalScene.propTypes = {
  markdown: PropTypes.object.isRequired,
  pageName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
